var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7548 9.55094C10.5375 9.55094 9.55073 10.5377 9.55073 11.755C9.55073 12.9723 10.5375 13.9591 11.7548 13.9591C12.9721 13.9591 13.9589 12.9723 13.9589 11.755C13.9589 10.5377 12.9721 9.55094 11.7548 9.55094Z",
    fill: "#1E1E22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7548 5.3877C9.19047 5.3877 6.88431 6.41762 5.22254 7.69301C4.39058 8.33154 3.70793 9.0407 3.22896 9.73087C2.75912 10.4079 2.44873 11.1198 2.44873 11.755C2.44873 12.3902 2.75912 13.1021 3.22896 13.7791C3.70793 14.4693 4.39058 15.1785 5.22254 15.817C6.88431 17.0924 9.19047 18.1223 11.7548 18.1223C14.3191 18.1223 16.6253 17.0924 18.2871 15.817C19.119 15.1785 19.8017 14.4693 20.2806 13.7791C20.7505 13.1021 21.0609 12.3902 21.0609 11.755C21.0609 11.1198 20.7505 10.4079 20.2806 9.73087C19.8017 9.0407 19.119 8.33154 18.2871 7.69301C16.6253 6.41762 14.3191 5.3877 11.7548 5.3877ZM8.08135 11.755C8.08135 9.72622 9.72601 8.08156 11.7548 8.08156C13.7836 8.08156 15.4282 9.72622 15.4282 11.755C15.4282 13.7838 13.7836 15.4285 11.7548 15.4285C9.72601 15.4285 8.08135 13.7838 8.08135 11.755Z",
    fill: "#1E1E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5cbff4e22f79afaa7130b54c9a03185b.svg";
export { ForwardRef as ReactComponent };